import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoadingService } from '../../../services/loading.service';

@Component({
    selector: 'loading-component',
    styleUrl: './loading.component.scss',
    templateUrl: './loading.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingComponent implements OnInit {
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() diameter: string = '50';

  constructor(public loadingService: LoadingService) {}

  ngOnInit(): void {
    this.loadingService.loading$.subscribe((value) => {
      this.isLoading$.next(false);
    })
  }
}
